"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailType = void 0;
var EmailType;
(function (EmailType) {
    EmailType["DUMMY"] = "DUMMY";
    EmailType["FEEDBACK"] = "FEEDBACK";
    EmailType["LINK_TOKEN"] = "LINK_TOKEN";
    EmailType["INVITE"] = "INVITE";
    EmailType["RAFFLE_PRIZE"] = "RAFFLE_PRIZE";
    EmailType["LOTTERY_PRIZE"] = "LOTTERY_PRIZE";
    EmailType["STAKING_BALANCE"] = "STAKING_BALANCE";
    EmailType["SUPPORT_LETTER"] = "SUPPORT_LETTER";
})(EmailType || (exports.EmailType = EmailType = {}));
//# sourceMappingURL=eml.js.map